// Formats whose images the RAG document pipeline can extract as figures: confirmed (pdf, docx) plus
// very-likely (pptx, same OOXML path). Mirrors the backend authority (agent-service
// FileType.supportsFigures) — keep the two sets in sync. Every other accepted format is ingested
// text-only: image extraction there is unverified, so the upload UI forces the "text only" toggle on,
// disables it, and explains that images aren't supported for the file type.
const FIGURE_EXTENSIONS = new Set(["pdf", "docx", "pptx"]);

const FIGURE_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);

/** True if the pipeline can extract images/figures from this file; otherwise it is ingested text-only. */
export function supportsFigures(fileName: string, mimeType?: string | null): boolean {
  const dot = fileName.lastIndexOf(".");
  if (dot >= 0 && FIGURE_EXTENSIONS.has(fileName.slice(dot + 1).toLowerCase())) {
    return true;
  }
  return !!mimeType && FIGURE_MIME_TYPES.has(mimeType.toLowerCase());
}
